// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#072D54', // SVS blue (normal buttons)
        secondary: '#05203B', // dark blue (panels)
        accent: '#82B1FF', // dim blue (not really used)
        error: '#D8454C', // red (e.g. delete buttons, errors and very important stuff)
        info: '#2196F3', // blue (e.g. special info buttons and info stuff)
        success: '#439946', // gree (e.g. create, save and primary buttons)
        warning: '#D6A22A' // yellow (e.g. warning buttons and be carefull stuff)
      },
      dark: {
        primary: '#072D54', // SVS blue (normal buttons)
        secondary: '#05203B', // dark blue (panels)
        accent: '#82B1FF', // dim blue (not really used)
        error: '#D8454C', // red (e.g. delete buttons, errors and very important stuff)
        info: '#2196F3', // blue (e.g. special info buttons and info stuff)
        success: '#439946', // gree (e.g. create, save and primary buttons)
        warning: '#D6A22A' // yellow (e.g. warning buttons and be carefull stuff)
      }
    }
  }
})
